import { BaseModel, Guid, RecursivePartial } from "@models/base";

export class WorkflowTriggerAction extends BaseModel {
    id?: Guid;
    type!: number;
    data?: any;

    constructor(json?: RecursivePartial<WorkflowTriggerAction>) {
        super(json);
        this.parseUnreadCounters(json || {});
    }

    parse(json: RecursivePartial<WorkflowTriggerAction>): WorkflowTriggerAction {
        super.parse(json);
        this.parseUnreadCounters(json);
        return this;
    }

    private parseUnreadCounters(json: RecursivePartial<WorkflowTriggerAction>): void {
        WorkflowTriggerAction.assignFields<WorkflowTriggerAction>(this, json, ['id', 'type', 'data']);
    }
}
